import React from "react";
import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import Num from '../common/Num';

function Row({ label, value, bold }) {
  return (
    <HStack justify="space-between" fontWeight={bold ? "bold" : undefined}>
      <Text>{label}</Text>
      <Text>€{value.toFixed(2)}</Text>
    </HStack>
  );
}

export default function SummaryBox({ summary }) {

  if (!summary) return null;

  const {
    imponibile, totaleSconti, netto,
    totaleOpzioni, iva, totale,
  } = summary;

  return (
    <Box
      position={{ base: "relative", md: "fixed" }}
      top="20%"
      right="20px"
      w="280px"
      bg="whiteAlpha.900"
      borderWidth="2px"
      borderRadius="2xl"
      boxShadow="xl"
      zIndex="popover"
      p={4}
    >
      <Text fontWeight="bold" mb={2}>
        Riepilogo
      </Text>

      <VStack align="start" spacing={1}>
        <Text>Imponibile:         <Num value={imponibile}      fmt="€" /></Text>
        <Text>{totaleSconti < 0 ? 'Sovrapprezzo:' : 'Totale sconti:'}      <Num value={Math.abs(totaleSconti)}    fmt="€" /></Text>
        <Text>Netto:              <Num value={netto}           fmt="€" /></Text>
        <Text>Totale Opzioni:     <Num value={totaleOpzioni}   fmt="€" /></Text>
        <Text>IVA (22%):          <Num value={iva}             fmt="€" /></Text>
        <Text fontWeight="bold">TOTALE: <Num value={totale}    fmt="€" /></Text>
        <Text
          as="i" 
          textDecoration="underline" 
          padding="2" 
          borderRadius="4" 
          fontWeight="hairline"
        >
          *L'importo indicato è relativo all'apparato senza considerare la configurazione interna.
          Necessaria comunicazione della stessa per emettere quotazione specifica.
        </Text>
      </VStack>
    </Box>
  );
}